import 'highlight.js/styles/solarized-light.css'

import App from './App.vue'
// Register global components
import AppCopyButton from '@/components/common/ui/buttons/AppCopyButton.vue'
import AppMaterialIcon from '@/components/common/ui/icons/AppMaterialIcon.vue'
import AppToolbar from '@/components/common/ui/AppToolbar.vue'
import Quasar from 'quasar/src/vue-plugin.js';
// Highlight.js languages (Only required languages)
import VueHighlightJS from 'vue3-highlightjs'
import { createApp } from 'vue'
import i18n from './plugins/i18n'
import panZoom from 'vue-panzoom'
import quasarUserOptions from './quasar-user-options'
import router from './router'
import store from './store'

const app = createApp(App)
  .use(Quasar, quasarUserOptions)
  .use(store)
  .use(router)
  .use(i18n)
  .use(VueHighlightJS)
  .use(panZoom)

app.component(
  'AppToolbar', AppToolbar
).component(
  'AppCopyButton', AppCopyButton
).component('AppMaterialIcon', AppMaterialIcon)
app.mount('#app')
